// Where the CRM is being viewed from. Only one surface cares today — Meta's Embedded Signup is a
// popup flow, and a popup is exactly what a phone (and above all an in-app webview) refuses to
// open — but the detection is kept out of the component so it can be tested as the pure string
// matching it is.

export type BrowserKind = "desktop" | "mobile" | "in_app_webview";

// Markers apps add to the UA when they render a page inside their own webview. `FBAN`/`FBAV`/
// `FB_IAB` are Facebook's, and `; wv)` is Android's own System WebView tag. Checked BEFORE the
// mobile markers because a webview is also a phone and the remedy is not the same: a phone can
// at least be told to use a computer, while a webview has to be escaped first ("abrir en el
// navegador") or nothing the user tries will work.
const WEBVIEW_MARKERS = [
  "FBAN",
  "FBAV",
  "FB_IAB",
  "Instagram",
  "Line/",
  "WhatsApp",
  "; wv)",
  "GSA/", // Google app
];

const MOBILE_MARKERS = ["Android", "iPhone", "iPad", "iPod", "Mobile Safari", "Opera Mini"];

/**
 * Classifies a user-agent string. Unknown strings fall back to `desktop`: this only drives a
 * warning, and warning a desktop operator about a phone would teach them to ignore it.
 */
export function detectBrowserKind(userAgent: string): BrowserKind {
  if (WEBVIEW_MARKERS.some((marker) => userAgent.includes(marker))) return "in_app_webview";
  if (MOBILE_MARKERS.some((marker) => userAgent.includes(marker))) return "mobile";
  return "desktop";
}

/** The live browser's kind. Safe to call during render; `navigator` always exists in the CRM. */
export function currentBrowserKind(): BrowserKind {
  if (typeof navigator === "undefined") return "desktop";
  return detectBrowserKind(navigator.userAgent);
}
